import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import getScrollFadeStyles from '../../../utils/getScrollFadeStyles.js';
import 'date-fns';

const useShadowStyle = (scrollPosition, withTopShadow, withBottomShadow) => {
    const theme = useTheme();
    return useMemo(() => {
        const style = {
            transition: `box-shadow linear ${theme.transitions.duration.fast}`,
        };
        if (scrollPosition) {
            const fadeStyles = getScrollFadeStyles(theme, withTopShadow, withBottomShadow);
            style.boxShadow = fadeStyles[scrollPosition];
        }
        return style;
    }, [scrollPosition, withTopShadow, withBottomShadow, theme]);
};

export { useShadowStyle as default };
//# sourceMappingURL=useShadowStyle.js.map
